import React from 'react';
import { motion } from 'framer-motion';

interface IconDataSecuritySupport {
  className?: string;
}

const IconDataSecurity = ({ className }: IconDataSecuritySupport) => {
  return (
    <motion.svg
      width="240"
      height="159"
      viewBox="0 0 240 159"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ''}
    >
      <path
        d="M40.4199 3.94619C29.2596 5.03942 18.299 14.3857 18.8007 25.7543C19.2512 35.8859 28.0207 43.831 29.792 53.8138C32.408 68.5647 19.3792 81.3652 16.712 96.1109C14.956 105.811 18.0891 116.292 24.8569 123.365C31.6299 130.442 41.8584 133.927 51.4676 132.439C64.1432 130.473 75.1652 120.562 87.9791 121.096C94.8442 121.383 100.87 122.4 107.248 125.176C112.798 127.594 118.148 130.54 123.927 132.331C135.436 135.893 148.373 134.502 158.872 128.564C163.178 126.131 167.079 122.98 171.512 120.788C175.162 118.981 179.396 117.821 183.471 118.571C187.475 119.305 191.555 119.685 195.589 120.516C203.836 122.215 212.734 124.499 220.822 120.916C226.172 118.545 230.411 113.392 231.931 107.741C233.994 100.063 232.781 91.004 227.749 84.768C222.855 78.7065 214.234 73.4713 214.387 64.7768C214.454 61.0147 215.913 57.386 217.95 54.2295C221.667 48.476 227.375 43.8926 229.51 37.3743C231.455 31.4411 229.991 24.7072 226.546 19.508C221.611 12.0761 212.995 7.88283 204.896 4.94703C191.974 0.261037 177.384 -1.50455 164.57 4.26441C160.833 5.94787 157.337 8.15999 153.518 9.64842C148.885 11.4551 144.646 11.3883 139.905 10.1668C134.345 8.73483 130.593 5.66045 126.185 2.24219C121.419 -1.45322 115.23 0.69217 110.627 3.47913C105.626 6.51245 102.098 12.5072 97.1581 15.6381C86.0491 22.6799 78.2829 17.9939 68.7711 12.2609C60.2524 7.11809 50.5461 2.95561 40.4199 3.94619Z"
        fill="#EDF5F0"
      />
      <motion.g
        initial={{ rotate: 0 }}
        animate={{ rotate: [0, 0.5, 0] }}
        transition={{
          duration: 4,
          repeat: Infinity,
        }}
      >
        <path
          d="M230.248 66.7945C230.248 66.7945 224.154 66.2456 220.93 65.1327C217.705 64.0198 216.857 62.6994 215.942 63.5765C215.026 64.4536 213.397 66.5625 211.169 72.522C208.94 78.4814 206.164 84.3952 202.401 83.9349C199.492 83.5762 198.954 78.6359 199.453 75.3663C199.952 72.0966 202.069 66.4335 205.261 64.0664C207.062 62.6859 209.269 61.9423 211.538 61.9524C211.538 61.9524 205.29 60.9241 201.442 62.3522C197.594 63.7803 196.716 65.2464 195.676 66.9337C194.636 68.621 192.091 75.572 191.774 79.8702C191.457 84.1683 192.268 88.68 190.601 89.526C188.934 90.372 186.314 87.3408 185.881 84.07C185.448 80.7992 185.986 75.4189 187.763 70.8431C189.539 66.2672 190.905 64.1243 193.443 63.082C190.208 63.1789 184.394 64.1938 181.307 66.2623C178.219 68.3308 176.652 70.7929 176.627 73.973C176.601 77.1532 178.683 90.1811 179.311 92.6057C179.94 95.0304 180.052 95.9548 179.207 96.3445C178.362 96.7342 176.137 94.6014 174.918 90.8593C173.667 86.8155 173.005 82.6126 172.952 78.38C172.936 76.094 173.596 73.8543 174.849 71.9421C171.216 73.2555 167.63 77.8242 165.165 81.0877C162.444 85.0053 160.137 89.1953 158.283 93.5902C157.575 95.7559 158.031 98.8865 158.625 100.308C159.218 101.73 163.333 107.884 164.859 110.276C166.385 112.669 169.959 115.294 173.017 114.74C177.982 113.833 183.829 110.202 183.829 110.202C183.829 110.202 180.153 116.924 182.559 122.623C184.966 128.322 190.148 130.348 196.77 131.092C203.393 131.836 211.301 124.862 214.2 122.465C217.099 120.069 223.18 111.558 223.18 111.558C219.512 112.917 215.626 113.59 211.715 113.545C205.707 113.342 201.217 112.437 199.119 111.093C197.02 109.749 197.985 108.222 199.016 108.1C200.048 107.979 202.818 108.285 206.83 109.093C210.842 109.901 219.898 110.759 223.609 108.887C226.005 107.674 227.934 105.704 229.096 103.282C229.871 101.634 230.32 94.8936 230.825 90.2941C228.895 92.6227 221.096 95.5929 217.469 96.4126C213.843 97.2323 210.637 97.3979 209.838 95.7459C209.039 94.0939 212.387 92.88 215.588 92.2541C218.789 91.6281 225.367 89.7236 228.384 87.869C228.936 87.6054 229.429 87.2329 229.834 86.7738C230.238 86.3147 230.545 85.7786 230.737 85.1978C230.835 84.49 230.011 81.217 229.413 77.9294C228.816 74.6417 228.308 71.8272 228.677 70.0171C228.973 68.8461 229.508 67.7489 230.248 66.7945Z"
          fill="#2A5B43"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M188.761 105.615C190.459 103.847 192.037 102.204 193.427 100.763C198.264 102.861 210.795 106.251 216.142 105.182C207.858 105.416 196.349 101.049 194.034 100.134C196.13 97.9612 197.733 96.3162 198.571 95.4975C199.712 94.3781 202.562 91.7744 205.826 88.7919C210.945 84.1151 217.083 78.5067 219.25 76.229C215.925 78.897 204.233 88.9346 196.968 95.8573C194.969 88.3091 194.953 80.3707 196.922 72.8113C193.358 81.9787 194.885 93.6782 196.172 96.6211C195.13 97.6269 194.199 98.5532 193.424 99.3638C192.523 100.303 190.604 102.061 188.069 104.312C185.617 99.4433 180.341 86.0758 180.565 79.2839C179.718 87.937 185.689 101.368 187.366 104.936C186.285 105.892 185.107 106.926 183.859 108.015C179.71 104.344 170.848 94.9042 170.156 89.8583C170.797 96.0824 180.238 105.475 183.373 108.438C178.592 112.605 172.868 117.517 167.677 121.972L167.676 121.973L167.676 121.973L167.675 121.973L167.675 121.974C160.225 128.367 153.874 133.818 152.991 134.764L152.847 136.718L152.63 139.651C153.51 138.615 156.566 135.929 160.618 132.369C167.099 126.673 176.126 118.739 182.864 111.747C183.742 110.835 184.61 109.933 185.461 109.048C192.01 114.924 202.655 118.182 205.716 117.644C198.381 116.623 191.525 113.417 186.04 108.446C186.968 107.48 187.875 106.537 188.749 105.627L188.755 105.621L188.757 105.619L188.761 105.615Z"
          fill="#3A8761"
        />
      </motion.g>
      <motion.g
        initial={{ rotate: 0 }}
        animate={{ rotate: [0, 10, 0] }}
        transition={{
          duration: 4,
          repeat: Infinity,
        }}
      >
        <path
          d="M14.0772 95.6492C13.4176 95.8416 12.8189 96.2485 12.4911 96.8565C11.1096 99.4348 15.302 100.879 17.007 101.402C20.1665 102.37 23.6025 102.98 26.6057 101.839C23.6071 99.2619 20.4458 96.5985 16.6898 95.7151C15.9159 95.5327 15.1146 95.4299 14.3508 95.5827C14.2585 95.5999 14.1667 95.6225 14.0772 95.6492Z"
          fill="#CEDFD5"
        />
        <path
          d="M24.193 90.2055C23.5311 89.9584 22.7934 89.9158 22.174 90.196C19.5439 91.3797 22.2401 95.0354 23.3769 96.4723C25.4773 99.1328 28.0133 101.68 31.185 102.596C30.1359 98.7739 28.999 94.786 26.3493 91.8327C25.8039 91.2243 25.1882 90.6622 24.4608 90.3197C24.374 90.2784 24.2833 90.2393 24.193 90.2055Z"
          fill="#CEDFD5"
        />
        <path
          d="M19.7993 110.255C19.6471 110.944 19.7043 111.702 20.0587 112.329C21.5585 114.984 24.7451 112.081 25.9875 110.865C28.2886 108.612 30.4204 105.916 30.8857 102.628C27.3171 103.844 23.5999 105.156 21.0888 107.985C20.5725 108.566 20.1084 109.219 19.8722 109.977C19.8456 110.067 19.8203 110.159 19.7993 110.255Z"
          fill="#CEDFD5"
        />
        <path
          d="M28.1156 112.831C28.0326 113.537 28.1613 114.286 28.5715 114.878C30.3109 117.381 33.189 114.157 34.3025 112.813C36.364 110.327 38.2197 107.417 38.3639 104.081C34.9466 105.658 31.3923 107.348 29.1758 110.428C28.7195 111.063 28.3229 111.761 28.1619 112.544C28.141 112.639 28.1263 112.737 28.1156 112.831Z"
          fill="#CEDFD5"
        />
        <path
          d="M35.5814 114.761C35.4984 115.466 35.6271 116.215 36.0373 116.807C37.7768 119.311 40.6548 116.087 41.7683 114.742C43.8298 112.256 45.6855 109.346 45.8297 106.01C42.4124 107.588 38.8581 109.277 36.6417 112.357C36.1853 112.992 35.7887 113.69 35.6278 114.474C35.6099 114.57 35.5941 114.665 35.5814 114.761Z"
          fill="#CEDFD5"
        />
        <path
          d="M41.9587 115.988C41.7332 116.651 41.7079 117.406 41.993 118.068C43.2036 120.862 46.7014 118.362 48.0762 117.302C50.6185 115.34 53.0439 112.921 53.8637 109.724C50.1666 110.518 46.3102 111.389 43.4945 113.895C42.914 114.41 42.3799 115.002 42.0637 115.725C42.0252 115.808 41.9904 115.898 41.9587 115.988Z"
          fill="#CEDFD5"
        />
        <path
          d="M49.8261 119.26C49.4857 119.864 49.3287 120.595 49.4984 121.293C50.2109 124.242 54.1202 122.45 55.6674 121.67C58.5356 120.227 61.3623 118.317 62.7357 115.352C58.9281 115.442 54.9482 115.577 51.7148 117.501C51.0493 117.896 50.4152 118.373 49.9763 119.021C49.9228 119.096 49.8729 119.177 49.8261 119.26Z"
          fill="#CEDFD5"
        />
        <path
          d="M33.7152 91.2098C33.0932 90.8592 32.3685 90.6983 31.7063 90.8728C28.9084 91.6072 31.0333 95.6262 31.9418 97.2172C33.6262 100.165 35.7582 103.071 38.7762 104.483C38.3188 100.569 37.7972 96.4748 35.6122 93.1504C35.1626 92.4674 34.6362 91.8148 33.9656 91.3619C33.8818 91.3077 33.7993 91.2555 33.7152 91.2098Z"
          fill="#CEDFD5"
        />
        <path
          d="M51.1779 96.7547C50.6039 96.3238 49.8989 96.0655 49.2186 96.1451C46.3323 96.4813 47.9254 100.733 48.625 102.425C49.9191 105.559 51.666 108.715 54.492 110.521C54.5472 106.605 54.5603 102.501 52.8141 98.9292C52.4549 98.1939 52.0161 97.4796 51.4033 96.9407C51.334 96.8753 51.257 96.8145 51.1779 96.7547Z"
          fill="#CEDFD5"
        />
        <path
          d="M59.6662 102.828C59.0921 102.397 58.3871 102.139 57.7069 102.218C54.8206 102.555 56.4137 106.806 57.1133 108.498C58.4074 111.633 60.1543 114.789 62.9803 116.595C63.0355 112.678 63.0485 108.575 61.3023 105.002C60.9431 104.267 60.5043 103.553 59.8915 103.014C59.8191 102.948 59.744 102.886 59.6662 102.828Z"
          fill="#CEDFD5"
        />
        <path
          d="M70.131 124.227C62.3705 111.858 48.4796 106.192 35.2652 103.263C31.182 102.358 27.07 101.652 22.9623 100.95C22.5257 100.875 22.3585 101.556 22.8002 101.631C36.3005 103.943 50.6547 106.472 61.7995 115.776C64.8072 118.287 67.4453 121.225 69.5424 124.569C69.7875 124.957 70.3785 124.619 70.131 124.227Z"
          fill="#CEDFD5"
        />
        <path
          d="M41.3724 93.4852C40.7505 93.1347 40.0257 92.9738 39.3636 93.1482C36.5656 93.8826 38.6905 97.9016 39.599 99.4926C41.2835 102.441 43.4154 105.346 46.4335 106.759C45.976 102.844 45.4544 98.7502 43.2694 95.4259C42.8198 94.7428 42.2934 94.0902 41.6228 93.6373C41.5403 93.5852 41.4577 93.533 41.3724 93.4852Z"
          fill="#CEDFD5"
        />
      </motion.g>
      <motion.g
        initial={{ rotate: 0 }}
        animate={{ rotate: [0, 8, 0] }}
        transition={{
          duration: 3,
          repeat: Infinity,
        }}
      >
        <path
          d="M45.8827 66.3865C45.3693 65.8789 44.7065 65.5213 44.0148 65.4994C41.0908 65.4026 42.0845 69.8144 42.5441 71.5814C43.3954 74.8526 44.6968 78.2131 47.26 80.4039C47.862 76.5623 48.4507 72.5343 47.2092 68.7647C46.9548 67.9883 46.6147 67.2225 46.0838 66.603C46.0208 66.5257 45.9531 66.4539 45.8827 66.3865Z"
          fill="#2B7B54"
        />
        <path
          d="M53.4638 73.4349C53.0221 72.8609 52.4096 72.4133 51.725 72.2902C48.8238 71.7699 49.2086 76.2533 49.4241 78.056C49.8229 81.3972 50.6574 84.8888 52.9116 87.4161C54.04 83.7279 55.1788 79.8535 54.4621 75.9667C54.3149 75.1671 54.082 74.3644 53.6351 73.677C53.5787 73.5931 53.5216 73.5124 53.4638 73.4349Z"
          fill="#2B7B54"
        />
        <path
          d="M33.0322 59.7173C32.3691 59.468 31.6334 59.4244 31.012 59.7057C28.3807 60.8873 31.073 64.5453 32.2059 65.9845C34.3036 68.6493 36.8356 71.1992 40.0066 72.1183C38.9626 68.2957 37.8316 64.3043 35.1847 61.3467C34.6392 60.7384 34.0255 60.1751 33.3001 59.8315C33.2133 59.7901 33.1245 59.7499 33.0322 59.7173Z"
          fill="#2B7B54"
        />
        <path
          d="M33.3053 76.0016C32.7176 76.3549 32.2409 76.9048 32.0692 77.5835C31.3527 80.4598 35.7121 80.831 37.4699 80.9193C40.7278 81.0812 44.1633 80.8243 46.7726 78.951C43.2916 77.1684 39.6322 75.3446 35.824 75.4147C35.0405 75.4291 34.2467 75.5299 33.5507 75.8682C33.4665 75.9085 33.3847 75.953 33.3053 76.0016Z"
          fill="#2B7B54"
        />
        <path
          d="M38.8459 83.5721C38.2582 83.9255 37.7814 84.4754 37.6098 85.1541C36.8933 88.0303 41.2527 88.4016 43.0105 88.4899C46.2683 88.6517 49.7038 88.3948 52.3132 86.5216C48.8322 84.7389 45.1727 82.9151 41.3645 82.9852C40.5811 82.9996 39.7873 83.1005 39.0913 83.4387C39.0102 83.48 38.9265 83.5256 38.8459 83.5721Z"
          fill="#2B7B54"
        />
        <path
          d="M60.3798 82.3384C59.9381 81.7644 59.3256 81.3168 58.6411 81.1937C55.7398 80.6734 56.1246 85.1568 56.3401 86.9595C56.7389 90.3007 57.5734 93.7923 59.8276 96.3196C60.956 92.6315 62.0948 88.7571 61.3782 84.8702C61.2309 84.0707 60.998 83.268 60.5511 82.5805C60.4979 82.4976 60.4408 82.4169 60.3798 82.3384Z"
          fill="#2B7B54"
        />
        <path
          d="M45.7716 92.4845C45.184 92.8378 44.7072 93.3877 44.5356 94.0664C43.8191 96.9426 48.1785 97.3139 49.9362 97.4022C53.1941 97.564 56.6296 97.3071 59.239 95.4339C55.7579 93.6512 52.0985 91.8275 48.2903 91.8976C47.5069 91.912 46.713 92.0128 46.017 92.351C45.934 92.3934 45.8522 92.4379 45.7716 92.4845Z"
          fill="#2B7B54"
        />
        <path
          d="M66.4189 90.7727C65.9772 90.1987 65.3647 89.7511 64.6801 89.628C61.7788 89.1077 62.1637 93.591 62.3791 95.3938C62.778 98.7349 63.6124 102.227 65.8667 104.754C66.9951 101.066 68.1339 97.1913 67.4172 93.3044C67.27 92.5049 67.0371 91.7022 66.5902 91.0148C66.535 90.9329 66.4779 90.8522 66.4189 90.7727Z"
          fill="#2B7B54"
        />
        <path
          d="M51.8063 100.911C51.2186 101.264 50.7419 101.814 50.5702 102.493C49.8537 105.369 54.2131 105.74 55.9709 105.829C59.2287 105.99 62.6643 105.733 65.2736 103.86C61.7926 102.078 58.1331 100.254 54.3249 100.324C53.5415 100.338 52.7477 100.439 52.0517 100.777C51.9675 100.818 51.8857 100.862 51.8063 100.911Z"
          fill="#2B7B54"
        />
        <path
          d="M75.4887 118.545C67.1975 104.822 57.7087 91.8355 47.1493 79.8137C44.1098 76.3536 40.9825 72.9774 37.7752 69.6806C37.4535 69.3507 36.9803 69.8431 37.3032 70.1751C48.453 81.6395 58.6076 94.1087 67.5767 107.412C70.1138 111.174 72.5516 115.004 74.8989 118.886C75.1386 119.283 75.7295 118.944 75.4887 118.545Z"
          fill="#16827C"
        />
      </motion.g>
      <path
        d="M85.3353 66.2665C85.036 65.6075 84.5402 65.026 83.8946 64.7389C81.1656 63.5229 80.4949 67.9172 80.2844 69.6998C79.8955 73.0024 79.8991 76.558 81.5214 79.539C83.4924 76.2793 85.5181 72.8464 85.7215 68.9411C85.7634 68.1377 85.723 67.3098 85.4445 66.5417C85.4122 66.4495 85.3748 66.3574 85.3353 66.2665Z"
        fill="#CEDFD5"
      />
      <path
        d="M74.8361 75.0418C74.2258 74.6706 73.5047 74.4798 72.8384 74.629C70.012 75.255 71.9913 79.3443 72.8428 80.9682C74.4207 83.9721 76.451 86.956 79.4193 88.4775C79.1032 84.5533 78.7292 80.4519 76.6637 77.053C76.2384 76.3531 75.7364 75.6836 75.0802 75.2058C75.0012 75.1461 74.9194 75.0908 74.8361 75.0418Z"
        fill="#CEDFD5"
      />
      <path
        d="M91.3953 80.3173C91.612 79.6487 91.6271 78.894 91.3321 78.2381C90.0837 75.4597 86.6223 78.0137 85.2666 79.0935C82.7523 81.0949 80.3639 83.5504 79.5884 86.7602C83.2709 85.9142 87.1122 84.9847 89.8925 82.436C90.465 81.9112 90.9891 81.3117 91.2978 80.5844C91.3319 80.4981 91.3636 80.4077 91.3953 80.3173Z"
        fill="#CEDFD5"
      />
      <path
        d="M73.0427 85.6582C72.392 85.3713 71.6599 85.284 71.0208 85.5256C68.3215 86.544 70.8096 90.3477 71.8619 91.8473C73.8124 94.6249 76.2026 97.315 79.3261 98.4196C78.4966 94.5508 77.5891 90.5107 75.1053 87.4089C74.5944 86.7695 74.0108 86.1721 73.3036 85.7875C73.2195 85.7418 73.1315 85.6984 73.0427 85.6582Z"
        fill="#CEDFD5"
      />
      <path
        d="M90.7371 91.29C90.9538 90.6213 90.9689 89.8667 90.6739 89.2108C89.4256 86.4324 85.9641 88.9864 84.6084 90.0662C82.0941 92.0676 79.7057 94.523 78.9302 97.7329C82.6127 96.8869 86.454 95.9574 89.2343 93.4087C89.8068 92.8839 90.3309 92.2844 90.6396 91.557C90.6737 91.4708 90.7066 91.3825 90.7371 91.29Z"
        fill="#CEDFD5"
      />
      <path
        d="M92.032 100.351C92.2487 99.6822 92.2638 98.9275 91.9688 98.2716C90.7205 95.4932 87.259 98.0472 85.9034 99.127C83.389 101.128 81.0006 103.584 80.2251 106.794C83.9076 105.948 87.749 105.018 90.5292 102.469C91.1017 101.945 91.6258 101.345 91.9346 100.618C91.9686 100.532 92.0015 100.443 92.032 100.351Z"
        fill="#CEDFD5"
      />
      <path
        d="M69.221 98.0137C68.5348 98.0829 67.8676 98.3712 67.4413 98.9086C65.6297 101.178 69.5496 103.339 71.1543 104.157C74.1281 105.669 77.4356 106.884 80.6131 106.307C78.0736 103.254 75.3855 100.085 71.8053 98.548C71.0686 98.2303 70.2887 97.9876 69.5048 97.9967C69.4093 97.9992 69.313 98.0049 69.221 98.0137Z"
        fill="#CEDFD5"
      />
      <path
        d="M82.1343 111.723C76.8318 98.9937 79.7281 85.1309 83.2989 72.7946C83.4239 72.3619 82.7525 72.1618 82.6276 72.5945C79.0291 85.0328 76.1242 99.0531 81.4713 111.887C81.6459 112.307 82.3126 112.149 82.1343 111.723Z"
        fill="#16827C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M146.774 128.889H152.636V128.749H146.774V128.889Z"
        fill="#EAEAE5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94.7246 121.696H110.104V88.0959H94.7246V121.696Z"
        fill="#E3E3DE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M110.557 106.195H137.325V90.8186H110.557V106.195Z"
        fill="#DCDDD7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M126.589 93.1449H121.293C118.993 93.1449 116.794 92.1984 115.212 90.5265H132.671C131.089 92.1984 128.889 93.1449 126.589 93.1449Z"
        fill="#EAEAE5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M110.475 121.696H107.555V113.378H113.538L110.475 121.696Z"
        fill="#F1F1ED"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M68.6299 121.696H99.6992V56.3578H68.6299V121.696Z"
        fill="#DCDDD7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M96.5737 121.697H99.6985V112.798H93.2969L96.5737 121.697Z"
        fill="#DCDDD7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M166.576 22.0268H75.5824C71.2515 22.0268 67.708 25.0435 67.708 28.7306V130.351C67.708 134.038 71.2515 137.055 75.5824 137.055H166.576C170.906 137.055 174.45 134.038 174.45 130.351V28.7306C174.45 25.0435 170.906 22.0268 166.576 22.0268Z"
        fill="#1E5D8F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M157.603 22.0266H69.9334C65.7607 22.0266 62.3467 26.3817 62.3467 30.0688V130.351C62.3467 134.037 65.7607 137.055 69.9334 137.055H157.603C161.776 137.055 165.19 133.186 165.19 129.5V30.0688C165.19 26.3817 161.776 22.0266 157.603 22.0266Z"
        fill="#4B81AC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M89.4009 139.492H76.236C75.8353 139.492 75.5068 139.269 75.5068 138.995V137.551C75.5068 137.278 75.8353 137.055 76.236 137.055H89.4009C89.8015 137.055 90.1291 137.278 90.1291 137.551V138.995C90.1291 139.269 89.8015 139.492 89.4009 139.492Z"
        fill="#413D45"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M151.3 139.492H138.135C137.735 139.492 137.407 139.269 137.407 138.995V137.551C137.407 137.278 137.735 137.055 138.135 137.055H151.3C151.701 137.055 152.029 137.278 152.029 137.551V138.995C152.029 139.269 151.701 139.492 151.3 139.492Z"
        fill="#413D45"
      />
      <path
        d="M83.5068 121.432C79.6408 121.432 76.5068 118.298 76.5068 114.432V44.6489C76.5068 40.783 79.6408 37.649 83.5068 37.6489L144.03 37.6486C147.896 37.6486 151.03 40.7826 151.03 44.6486V114.432C151.03 118.298 147.896 121.432 144.03 121.432H83.5068Z"
        fill="#6AA3D3"
        stroke="#413D45"
        strokeWidth="2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M113.735 52.9276C112.993 52.9276 112.291 52.7541 111.668 52.4445C110.146 51.6766 109.103 50.0987 109.103 48.2773C109.103 45.7009 111.189 43.6125 113.763 43.6125C114.508 43.6125 115.212 43.7877 115.836 44.0989C117.355 44.8674 118.395 46.4436 118.395 48.2633C118.395 50.8392 116.309 52.9276 113.735 52.9276Z"
        fill="#413D45"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M113.764 51.9612C111.733 51.9612 110.082 50.3083 110.082 48.2764C110.082 46.2446 111.733 44.5911 113.764 44.5911C115.794 44.5911 117.445 46.2446 117.445 48.2764C117.445 50.3083 115.794 51.9612 113.764 51.9612Z"
        fill="#3367A3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M76.6924 60.5677H74.6217C74.166 60.5677 73.793 60.1949 73.793 59.7382V48.379C73.793 47.9228 74.166 47.55 74.6217 47.55H76.6924C77.1481 47.55 77.5206 47.9228 77.5206 48.379V59.7382C77.5206 60.1949 77.1481 60.5677 76.6924 60.5677Z"
        fill="#3367A3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M77.3478 61.9945H74.6403C74.0443 61.9945 73.5566 61.5757 73.5566 61.0627V48.3034C73.5566 47.791 74.0443 47.3723 74.6403 47.3723H77.3478C77.9437 47.3723 78.4307 47.791 78.4307 48.3034V61.0627C78.4307 61.5443 78.0015 61.9423 77.456 61.9894C77.4209 61.9926 77.3844 61.9945 77.3478 61.9945Z"
        fill="#413D45"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M76.6924 111.758H74.6217C74.166 111.758 73.793 111.384 73.793 110.929V99.5689C73.793 99.1122 74.166 98.7394 74.6217 98.7394H76.6924C77.1481 98.7394 77.5206 99.1122 77.5206 99.5689V110.929C77.5206 111.384 77.1481 111.758 76.6924 111.758Z"
        fill="#3367A3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M77.3478 111.71H74.6403C74.0443 111.71 73.5566 111.318 73.5566 110.841V98.932C73.5566 98.4532 74.0443 98.0624 74.6403 98.0624H77.3478C77.9437 98.0624 78.4307 98.4532 78.4307 98.932V110.841C78.4307 111.289 78.0015 111.661 77.456 111.706C77.4209 111.709 77.3844 111.71 77.3478 111.71Z"
        fill="#413D45"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M140.819 81.4902C140.819 95.2185 129.309 106.348 115.111 106.348C114.742 106.348 114.376 106.341 114.012 106.326C127.7 105.769 138.621 94.8628 138.621 81.4902C138.621 68.1184 127.7 57.212 114.012 56.6551C114.376 56.6405 114.742 56.6325 115.111 56.6325C129.309 56.6325 140.819 67.7619 140.819 81.4902Z"
        fill="#1E5D8F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M138.878 81.422C138.878 95.166 127.634 106.307 113.764 106.307C99.8937 106.307 88.6494 95.166 88.6494 81.422C88.6494 67.6788 99.8937 56.5373 113.764 56.5373C127.634 56.5373 138.878 67.6788 138.878 81.422Z"
        fill="#4B81AC"
      />
      <motion.path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M101.778 68.5131C104.914 65.6529 109.097 63.9042 113.685 63.9042C118.312 63.9042 122.527 65.6831 125.672 68.5871L125.671 68.5879L125.67 68.5874L125.67 68.5876C125.643 68.5625 125.616 68.5375 125.588 68.5124L125.588 68.5124L125.588 68.5122L118.782 75.2568C118.811 75.2807 118.84 75.3045 118.868 75.3284L118.868 75.3286C117.473 74.1468 115.663 73.433 113.684 73.433C111.746 73.433 109.969 74.1178 108.586 75.2566L101.78 68.5122L101.779 68.5137L101.778 68.5131ZM100.737 69.5452C97.8533 72.6514 96.0902 76.7944 96.0902 81.3379C96.0902 85.8827 97.8546 90.0271 100.74 93.1337L107.546 86.3897C106.396 85.0201 105.705 83.2592 105.705 81.3387C105.705 79.419 106.395 77.6592 107.544 76.2897L100.737 69.5452ZM101.865 94.2404C104.99 97.0544 109.139 98.7716 113.685 98.7716C118.27 98.7716 122.451 97.0245 125.586 94.1669L118.78 87.423L118.779 87.4236C117.397 88.5606 115.621 89.2444 113.684 89.2444C111.787 89.2444 110.044 88.5882 108.675 87.4923L101.865 94.2404ZM126.629 93.1331C129.515 90.0266 131.279 85.8824 131.279 81.3379C131.279 76.8334 129.546 72.7227 126.706 69.6256L119.895 76.3751C121 77.732 121.663 79.4587 121.663 81.3387C121.663 83.2597 120.972 85.0209 119.822 86.3905L119.823 86.389L126.629 93.1331ZM94.6172 81.3379C94.6172 91.7562 103.171 100.231 113.685 100.231C124.199 100.231 132.752 91.7562 132.752 81.3379C132.752 70.9203 124.199 62.4446 113.685 62.4446C103.171 62.4446 94.6172 70.9203 94.6172 81.3379Z"
        fill="#413D45"
        transition={{
          duration: 3,
          repeat: Infinity,
          repeatDelay: 0.8,
        }}
        animate={{
          rotate: [0, 360, 0],
        }}
      />
    </motion.svg>
  );
};

export default IconDataSecurity;
